/**
 * CAB Meeting Management email policy (frontend mirror of
 * backend/src/utils/cabEmailPolicy.ts — the backend remains the authority;
 * this exists only for early validation and clearer UX messages).
 */
export const ALLOWED_CAB_EMAIL_DOMAINS = ['tenarai.com', 'infogain.com', 'igglobal.com'];

export const CAB_EMAIL_POLICY_MESSAGE = `Only internal company email addresses ending in ${ALLOWED_CAB_EMAIL_DOMAINS.map(
  (d) => `@${d}`
).join(', ')} are allowed for CAB Meeting Management.`;

/** Case-insensitive, whitespace-trimmed, full-domain match (no substring checks). */
export function isAllowedCabEmail(email: string | null | undefined): boolean {
  if (typeof email !== 'string') return false;
  const normalized = email.trim().toLowerCase();
  const parts = normalized.split('@');
  if (parts.length !== 2 || !parts[0] || !parts[1]) return false;
  return ALLOWED_CAB_EMAIL_DOMAINS.includes(parts[1]);
}
